
// アコーディオン
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.buttonElement = accordionElement.querySelector(".js-accordion__trigger");
    this.contentElement = accordionElement.querySelector(".js-accordion__content");
    this.isOpen = true; // 初期状態を開いた状態に設定
    this.accordionElement.classList.add("is-active"); // 初期状態でis-activeクラスを追加
    this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px"; // maxHeightに初期値を設定

    this.buttonElement.addEventListener("click", () => {
      this.toggleAccordion();
    });
  }
  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.accordionElement.classList.toggle("is-active", this.isOpen);
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.maxHeight = null; // maxHeightをnullに設定して閉じる
    }
  }
}
function initAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}


// Mutation Observerを設定する関数
function initializeDrawerAccordionObserver() {
  const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              let hasAccordion = Array.from(mutation.addedNodes).some(node => 
                  node.nodeType === 1 && // 要素ノードのみを対象
                  (node.classList.contains('js-accordion') || node.querySelector('.js-accordion'))
              );
              if (hasAccordion) {
                  // .js-accordionを含む要素が追加されたので、initAccordions関数を実行
                  initAccordions();
              }
          }
      }
  };

  const observerOptions = {
      childList: true,
      subtree: true
  };

  const drawer = document.querySelector('#drawer');
  if (drawer) {
      const observer = new MutationObserver(callback);
      observer.observe(drawer, observerOptions);
  }
}




/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  // ここに処理関数を記述
  initializeDrawerAccordionObserver();
});

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */
let currentWidth = window.innerWidth;
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (currentWidth === window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    // ここに処理関数を記述
    currentWidth = window.innerWidth;
  }, 200);
});